import templateContent from './template_content';

const showTemplateFlash = (name, message) => {
  const flash = templateContent(document.querySelector(`template[data-flash-template="${name}"]`));
  const level = [...flash.classList].find((className) => className.startsWith('is-'));

  flash.querySelector('[data-alert-target="message"]').textContent = message;
  document.querySelectorAll(`#flash_messages .ui--flash.${level}`).forEach((el) => el.remove());
  document.getElementById('flash_messages').append(flash);
};

export default showTemplateFlash;
